import React from 'react';
import './Header.css';
import decoration from './decoration.png';
import plane from './Plane.png';
import hotel from './Hotel.png';
import car from './Car.png';
import location from './Location.png';
import vector from './Vector.png';
import calendar from './Calendar.png';

function Header() {
  return (
    <header className="header">
      <div className="text-container">
        {/* Title */}
        <h1 className="title">
          Let's go! <br />
          The <span className="highlight">adventure</span> is waiting for you
        </h1>
        {/* Subtitle */}
        <p className="subtitle">
          Pack your luggage and pick your destination, we will provide you the flight ticket, hotel booking, and best guides.
        </p>
        {/* Main container */}
        <div className="main">
          {/* Row 1: Flight, Hotel, Rent */}
          <div className="row3">
            <div className="items">
              <div className="image-container">
                <img src={plane} alt="plane" className="img" />
              </div>
              <h1 className="item-title">Flight</h1>
            </div>
            <div className='items2'>
            <div className="items">
              <div className="image-container">
                <img src={hotel} alt="hotel" className="img" />
              </div>
              <h1 className="item-title">Hotel</h1>
            </div>
            <div className="items">
              <div className="image-container">
                <img src={car} alt="car" className="img" />
              </div>
                <h1 className="item-title">Rent</h1>
            </div>
            </div>
          </div>
          {/* Row 2: Destination, Date, and Button */}
          <div className="row row-destination">
            {/* Destination */}
            <div className="box">
              <h1 className="label">Destination</h1>
              <div className="row1">
                <img src={location} alt="Destination icon" className="icon" />
                <h1 className="text">Paris, France</h1>
                <img src={vector} alt="Dropdown icon" className="icon1" />
              </div>
            </div>
            {/* Date */}
            <div className="box">
              <h1 className="label">Date</h1>
              <div className="row1">
                <img src={calendar} alt="Calendar icon" className="icon" />
                <h1 className="text">21-11-2024</h1>
                <img src={vector} alt="Dropdown icon" className="icon1" />
              </div>
            </div>
            {/* Button */}
            <button className="search-button">Search</button>
          </div>
        </div>
      </div>
      {/* Right-side image */}
      <div className="side-image-container">
        <img src={decoration} alt="Decoration" className="side-image" />
      </div>
    </header>
  );
}

export default Header;
